/**
 * Represente une socket.
 */
export class Socket {
    public code: string;

    public label: string;

    /**
     * Constructeur.
     */
    public constructor() {}

    /**
     * Retourne une copie d'une instance de Socket
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Socket): Socket {
        if (!!other) {
            const instance = new Socket();
            instance.code = other.code;
            instance.label = other.label;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de State
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: Socket[]) {
        if (!!others) {
            let sockets: Socket[] = [];

            others.forEach((x) => {
                const socket = Socket.clone(x);
                sockets.push(socket);
            });

            return sockets;
        } else {
            return [];
        }
    }
}
